export const CTA_BANNER_1 = '<CTABanner1>';
export const CTA_BANNER_WEBSITE_EN = '<CTABanner_WebsiteEN>';
export const CTA_BANNER_BUDGET_EN = '<CTABanner_BudgetEN>';
export const CTA_BANNER_CHECKLIST_EN = '<CTABanner_ChecklistEN>';
export const CTA_BANNER_GUESTLIST_EN = '<CTABanner_GuestlistEN>';
export const CTA_BANNER_VISION_EN = '<CTABanner_VisionEN>';
export const CTA_BANNER_STATIONERY_EN = '<CTABanner_StationeryEN>';
export const CTA_BANNER_VENUES_EN = '<CTABanner_VenuesEN>';
export const CTA_BANNER_PHOTOG_EN = '<CTABanner_PhotogEN>';
export const CTA_BANNER_FLORISTS_EN = '<CTABanner_FloristsEN>';
export const CTA_BANNER_VIDEO_EN = '<CTABanner_VideoEN>';
export const CTA_BANNER_CATERING_EN = '<CTABanner_CateringEN>';
export const CTA_BANNER_DRESSES_EN = '<CTABanner_DressesEN>';
export const CTA_BANNER_ENTERTAINMENT_EN = '<CTABanner_EntertainmentEN>';
export const CTA_BANNER_CAKES_EN = '<CTABanner_CakesEN>';
export const CTA_BANNER_HAIR_BEAUTY_EN = '<CTABanner_HairBeautyEN>';
export const CTA_BANNER_TRANSPORT_EN = '<CTABanner_TransportEN>';
export const CTA_BANNER_MUSIC_EN = '<CTABanner_MusicEN>';
export const NWS_DISCOUNT_CARD = '<NWSDiscountCard>';
